export default "__VITE_ASSET__CJEkq7pz__"